import React from 'react';
import styles from './PaymentInstructions.module.css';
import Visa from '../../assets/images/Visa.png';
import Mastercard from '../../assets/images/Mastercard.png';
import Belcart from '../../assets/images/Belcart.png';
import BePaid from '../../assets/images/bePaid.png';
import GPay from '../../assets/images/GPay.png';
import { PaymentMethod } from 'components/PaymentMethods/PaymentMethods';

type Props = {method: PaymentMethod}

const PaymentInstructions: React.FC<Props> = ({method}) => {

    return (
        <section className={styles['paymentInstructions-section']} >
        <div className={styles['paymentInstructions-container']}>
        <div className={styles['paymentInstructions-content']}>
            {method === 'card' && (
                <>
                <h2 className={styles['paymentInstructions-title']}>
                    Банковской карточкой через интернет
                </h2>
                <p className={styles['paymentInstructions-lead']}>Для этого вам необходимо (пример):</p>
                <ol className={styles['paymentInstructions-list']}>
                    <li className={styles['paymentInstructions-step']}>Заказать услугу, которую вы хотите получить, любым удобным для вас способом:
                    позвонить по телефону: <a className={styles['paymentInstructions-link']} href="tel:+375XXXXXXXXX">+375 (xx) xxx-xx-xx</a> или написать e-mail: <a className={styles['paymentInstructions-link']} href="mailto:xxxx@xxxx.by">xxxx@xxxx.by</a>.</li>
                    <li className={styles['paymentInstructions-step']}>В течение <strong>10 минут</strong> мы вышлем на ваш e-mail ссылку для оплаты услуги. Кликнув на ссылку, вы перейдете на специальную защищенную платежную страницу процессинговой системы <a className={`${styles['paymentInstructions-link']} ${styles['text-underline']}`} href="https://bepaid.by/kak-oplatit">bePaid</a></li>
                    <li className={styles['paymentInstructions-step']}> На платежной странице будет указан номер заказа и сумма платежа. Для оплаты вам необходимо ввести свои карточные данные и подтвердить платеж, нажав кнопку «Оплатить».
                      <p className={styles.note}>
                        Если ваша карта поддерживает технологию 3-D Secure, системой вам будет предложено пройти стандартную одноминутную процедуру проверки владельца карты на странице вашего банка (банка, который выдал вашу карту).
                      </p>
                    </li>
                    <li className={styles['paymentInstructions-step']}>После оплаты <strong> наш менеджер свяжется с вами для уточнения деталей оказания услуги</strong> <span className={styles['text-italic']}>(к консультации удобным для вас способом: онлайн-консультация, личная встреча).</span> </li>
                </ol>
                <p className={styles['paymentInstructions-notice']}>
                    Обращаем ваше внимание: после проведения платежа на указанный вами e-mail придёт <strong className={styles['text-underline']}> подтверждение оплаты </strong>. Мы принимаем Visa, Visa Electron, MasterCard, Maestro, Белкарт.
                </p>
                <div className={styles['paymentInstructions-payments']}>
                    <img src={Visa} alt="Visa" />
                    <img src={Mastercard} alt="Mastercard" />
                    <img src={Belcart} alt="Belcart" />
                    <img src={BePaid} alt="BePaid" />   
                    <img src={GPay} alt="Google Pay" />                 
                </div>
                <p className={styles['paymentInstructions-text']}>
                    Платежи по банковским картам осуществляются через систему электронных платежей <a className={styles['paymentInstructions-link']} href="https://bepaid.by/kak-oplatit">bePaid</a>.
                    Платёжная страница соответствует требованиям безопасности передачи данных (PCI DSS Level 1).
                    Конфиденциальные данные хранятся в зашифрованном виде. Доступ к авторизационным страницам
                    осуществляется по протоколу SSL/TLS.
                </p>
                <p className={styles['paymentInstructions-text']}>
                    Возврат денежных средств осуществляется на карту, с которой ранее был произведён платёж.
                    Срок поступления денежных средств — от 1 до 30 дней, в зависимости от банка-эмитента.
                </p>
                <p className={styles['paymentInstructions-text']}>
                    Условия возврата: <a>ознакомьтесь с политикой возвратов</a>.
                </p>
            </>
            )}

            {method === 'qr' && (
                <>
                <p className={styles['paymentInstructions-text']}>Оплатить заказ Вы можете через систему "Расчет" (ЕРИП), в любом удобном для Вас месте, в удобное для Вас время, в удобном для Вас пункте банковского обслуживания – интернет-банке, с помощью мобильного банкинга, инфокиоске, кассе банков, банкомате и т.д.
                Совершить оплату можно с использованием наличных денежных средств, электронных денег и банковских платежных карточек, в пунктах банковского обслуживания банков, которые оказывают услуги по приему платежей, а также посредством инструментов дистанционного банковского обслуживания.
                </p>
                <h3 className={styles['paymentInstructions-lead']}>ДЛЯ ПРОВЕДЕНИЯ ПЛАТЕЖА НЕОБХОДИМО:</h3>
                <ol className={styles['paymentInstructions-list']}>
                    <li className={styles['paymentInstructions-step']}>
                        <p>Выбрать</p>
                        <ul className={styles.sublist}>
                            <li>Пункт “Система “Расчет” (ЕРИП)</li>
                            <li>Группа услуг</li>
                            <li>Подгруппа услуг</li>
                            <li>Территориальное расположение</li>
                            <li>Каталог с наименованием организации</li>
                            <li>Выбрать оплачиваемую услугу</li>                        
                        </ul>
                     <p>Для оплаты ввести <span className={styles['italic-bold']}>Номер заказа</span></p>
                    </li>
                    <li className={styles['paymentInstructions-step']}>Проверить корректность информации </li>
                    <li className={styles['paymentInstructions-step']}>Совершить платеж</li>
                </ol>
                <p className={styles['paymentInstructions-text']}>Если Вы осуществляете платеж в кассе банка, пожалуйста, сообщите кассиру о необходимости проведения платежа через систему ”Расчет“ (ЕРИП)</p>
                <p className={styles['paymentInstructions-lead']}>Вы также можете оплатить заказ по коду услуги в ЕРИП:</p>
                <ul className={styles['paymentInstructions-list']}>
                    <li className={styles['paymentInstructions-step']}>Пункт “Система “Расчет” (ЕРИП)</li>
                    <li className={styles['paymentInstructions-step']}>Оплата в ЕРИП по коду услуги</li>
                    <li className={styles['paymentInstructions-step']}>Вводите код ********</li>
                </ul>
                </> 
            )}

            {method === 'erip' && (
                <>
                <h2 className={styles['paymentInstructions-title']}>Как оплатить через систему "Расчет" (ЕРИП)</h2>
                <p className={styles['paymentInstructions-text']}>Оплатить заказ Вы можете через систему "Расчет" (ЕРИП), в любом удобном для Вас месте, в удобное для Вас время, в удобном для Вас пункте банковского обслуживания – интернет-банке, с помощью мобильного банкинга, инфокиоске, кассе банков, банкомате и т.д.
                Совершить оплату можно с использованием наличных денежных средств, электронных денег и банковских платежных карточек, в пунктах банковского обслуживания банков, которые оказывают услуги по приему платежей, а также посредством инструментов дистанционного банковского обслуживания.
                </p>
                <h3 className={styles['paymentInstructions-lead']}>ДЛЯ ПРОВЕДЕНИЯ ПЛАТЕЖА НЕОБХОДИМО:</h3>
                <ol className={styles['paymentInstructions-list']}>
                    <li className={styles['paymentInstructions-step']}>
                        <p>Выбрать</p>
                        <ul className={styles.sublist}>
                            <li>Пункт “Система “Расчет” (ЕРИП)</li>
                            <li>Группа услуг</li>
                            <li>Подгруппа услуг</li>
                            <li>Территориальное расположение</li>
                            <li>Каталог с наименованием организации</li>
                            <li>Выбрать оплачиваемую услугу</li>                        
                        </ul>
                     <p>Для оплаты ввести <span className={styles['italic-bold']}>Номер заказа</span></p>
                    </li>
                    <li className={styles['paymentInstructions-step']}>Проверить корректность информации </li>
                    <li className={styles['paymentInstructions-step']}>Совершить платеж</li>
                </ol>
                <p className={styles['paymentInstructions-text']}>Если Вы осуществляете платеж в кассе банка, пожалуйста, сообщите кассиру о необходимости проведения платежа через систему ”Расчет“ (ЕРИП)</p>
                <p className={styles['paymentInstructions-lead']}>Вы также можете оплатить заказ по коду услуги в ЕРИП:</p>
                <ul className={`${styles['paymentInstructions-list']} ${styles.sublist}`}>
                    <li className={styles['paymentInstructions-step']}>Пункт “Система “Расчет” (ЕРИП)</li>
                    <li className={styles['paymentInstructions-step']}>Оплата в ЕРИП по коду услуги</li>
                    <li className={styles['paymentInstructions-step']}>Вводите код ********</li>
                </ul>
                </> 
            )}            

        </div>
        </div>
        </section>
    );
};

export default PaymentInstructions;